<ng-select (change)="onSelectElement()" (scrollToEnd)="onGetMoreItems()" (search)="onSearch($event)"
    [(ngModel)]="souscripteur_id" placeholder="Choisissez souscripteur " name="souscripteur_id" id="souscripteur_id"
    [multiple]="false" [closeOnSelect]="true">
    <ng-option *ngFor="let item of items" [value]="item.id">{{ item.libelle}}
    </ng-option>
</ng-select>